import React, { useState, useEffect } from 'react'


const NumberSpinner = props => {
  let { value, preferenceName, min, max, storeEdits } = props
  const [tempValue, setTempValue] = useState(value)

  useEffect(() => {
    if (tempValue !== value) {
      setTempValue(value)
    }
  }, [value])

  const handleChange = ev => {
    // restrict the number to the preferences range only when changes are final
    if (!min) min = 0
    if (!max) max = Infinity
    const result = Math.min(Math.max(tempValue, min), max)
    storeEdits(result)
    if (result !== tempValue) {
      setTempValue(result)
    }
  }

  return (
    <div className="form-group">
      <div className="inline-label-wrapper">
        <label>
          {min || 0} - {max || Infinity}
        </label>
        <input
          value={tempValue}
          className="form-control"
          type="number"
          min={min}
          max={max}
          onBlur={handleChange}
          onChange={ev => {
            const inProgressValue = ev.target.value
            setTempValue(inProgressValue)
            // only store the in progress value if it is valid
            // do this because if focus goes from this component directly to save changes, the change will be lost
            if (inProgressValue >= (min || 0) && inProgressValue <= (max || Infinity)) {
              storeEdits(inProgressValue)
            }
          }}
        />
      </div>
    </div>
  )
}

export default NumberSpinner
